module.exports = __webpack_public_path__ + "static/media/Dever_Stephen_Resume.c2432cd0.pdf";